export default "__VITE_ASSET__DOc_qEZQ__"